<template>
  <ui-button
    outlined
    :href="url"
    target="blank"
    rel="noopener noreferrer"
    class="map-btn"
  >
    <component :is="iconComponents[icon]" />
    <div class="map-btn__content">
      <div>
        {{ $t("message.facilityDetails.showIn") }}
      </div>
      <div>
        {{ label }}
      </div>
    </div>
  </ui-button>
</template>

<script>
export default {
  name: "MapButton",
  components: {},
  props: {
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },

  computed: {
    iconComponents() {
      return {
        google: () => import("@/components/ui/Icons/GoogleMapsIcon.vue"),
        bing: () => import("@/components/ui/Icons/BingIcon.vue"),
        apple: () => import("@/components/ui/Icons/AppleIcon.vue")
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.map-btn {
  padding-left: $spacing * 1.5 !important;
  padding-right: $spacing * 2.5 !important;
  text-align: left;
  flex-shrink: 1;
  width: 100%;
  justify-content: flex-start;

  &__content {
    div:first-child {
      @include font-size(10px);
    }
  }
}
</style>
